import React from "react";
import IconInfoMessage from "../../Resources/svg/Icons/IconMessage";

const InfoMessage = ({ text }: { text: string }) => {
  return (
    <div className="info-box">
      <div className="info-box__text">
        <IconInfoMessage />
        {text}
      </div>
    </div>
  );
};

export default InfoMessage;
